
import Loading from 'vux/src/components/loading/index.vue'

export default {
name: 'app',
data () {
return {
}
},
components: {
Loading
},
created () {
},
mounted () {

},
watch: {
'$route': function (to, from) {

}
},
methods: {

},
computed: {
isLoading: function () {
return this.$store.state.isLoading
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue